import { NgModule } from '@angular/core';
import { ExtraOptions, PreloadAllModules, RouterModule, Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/apps/vacancies',
  },
  {
    path: 'oneid',
    loadChildren: () =>
      import('./modules/Auth/oneid/oneid.module').then(m => m.OneidModule),
  },
  {
    path: 'sign-out',
    loadChildren: () => import('./modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)
  },
  {
    path: 'apps',
    loadChildren: () =>
      import('./modules/apps/apps.module').then(m => m.AppsModule),
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./modules/pages/pages.module').then(m => m.PagesModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/pages/404',
  },
];

const extraOptions: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled',
  useHash: true,
}

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, extraOptions),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }
